<template>
  <div class="conferences-wrap">
    <div class="container mx-auto px-6">

      <h2 class="text-3xl font-bold text-center mb-8 text-yellow-700 uppercase">
        Conférences – Dies Academicus
      </h2>

      <div class="content-text">
        <p class="mb-4">
          Les Conférences de l’EITP sont des communications académiques ou spirituelles, 
          en mode participatif, sur des questions d’actualités aux divers enjeux sociaux, politiques, religieux. 
          D’une manière formelle, est également organisée chaque année, une Journée académique (Dies academicus) 
          qui se décline essentiellement en conférence magistrale, travaux en ateliers et remontée, débats, etc.
        </p>

        <ul class="list-disc ps-4">
          <li class="mb-2">
            <strong>Mercredi 4 mars 2020 :</strong> Présentation de <em>Querida Amazonia</em> (François) et <em>Des profondeurs de nos cœurs</em> (Benoît XVI et cardinal Robert Sarah). Cette soirée consistait en une contemplation du mystère de l’Eglise dans sa double dimension humano divine.
          </li>
          <li class="mb-2">
            <strong>Samedi 4 janvier 2020 :</strong> Dies academicus sur « Construction de notre identité. Repères et axes », par Madame Rolande Degboè, docteur en Sociologie-Anthropologie. La définition du concept de l’identité dans une perspective pluridisciplinaire (anthropologique, sociologique, …)
          </li>
          <li class="mb-2">
            <strong>Mercredi 8 janvier 2019 :</strong> Présentation de <em>Mémoire d’une vie</em>. Entretien avec Rodrigue Gbédjinou de Mgr Antoine Ganyé. Après une messe d’action de grâce pour son Jubilé d’Or, Mgr Antoine a échangé avec les disciples d’Emmaüs présents.
          </li>
          <li class="mb-2">
            <strong>Samedi 5 janvier 2019 :</strong> Dies academicus sur « L’engagement politique des chrétiens laïcs à la lumière de l’encyclique ‘‘Africæ munus’’ », par l’Ambassadeur Théodore C. Loko, enseignant-chercheur de Droit à l’Université d’Abomey-Calavi.
          </li>
          <li class="mb-2">
            <strong>Mercredi 13 juin 2018 :</strong> Présentation de <em>Gaudete et exultate</em> du Pape François par le Père Rodrigue Gbédjinou, directeur de l’EITP. Des pistes ont été dégagées pour échange en vue d’une appropriation personnelle de l’encyclique.
          </li>
          <li class="mb-2">
            <strong>Samedi 7 avril 2018 :</strong> Dies academicus sur « Les phénomènes paranormaux à la lumière de la foi chrétienne : entre pathologies religieuses et sociales », par Monsieur Paul Christian Kiti, enseignant chercheur de Philosophie à l’Université d’Abomey-Calavi.
          </li>
        </ul>

      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ConfeRence", 
  setup() {
    return {};
  },
});
</script>

<style scoped>
.conferences-wrap {
  background-color: #fff;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

h2 {
  color: #2b3a67;
}

.content-text p {
  margin-bottom: 1rem;
}

.content-text ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  line-height: 1.8;
}
</style>
